export enum TokenKeys {
	AW_TOKEN = "awtoken",
	AW_REFRESH_TOKEN = "awrefreshtoken",
}
